import { getViewerIdAndKind } from '../../../../infra/session';
export var getCampaignOwnerOrViewerIdAndKind = function (campaign, session) {
    if (campaign) {
        return {
            id: campaign.ownerId,
            kind: campaign.ownerType,
        };
    }
    return getViewerIdAndKind(session);
};
